import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import UserSubscriptionList from './UserSubscriptionList';
import UserSubscriptionEdit from './UserSubscriptionEdit';

export default {
    list: UserSubscriptionList,
    edit: UserSubscriptionEdit,
    icon: WorkspacePremiumIcon,
    recordRepresentation: (record: any) => `#${record?.id || ''}`,
};
